"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var js_utils_1 = require("./utils/js_utils");
exports.isFirefox = js_utils_1.memoize(function () {
    return /firefox/i.test(navigator.userAgent);
});
exports.isSafari = js_utils_1.memoize(function () { return Boolean(window.safari); });
